import Environment from "../environment";

import Api from "./ApiService";
import { AuthService } from "./AuthService";

import Comprobante from "../models/Comprobante";

export const ComprobanteService = {
    comprobantes: (uf, data) => {
        return new Promise((resolve, reject) => {
            return Api.fetch(
                `${Environment.api}api/unidades-facturaciones/${uf}/comprobantes-cobrados`,
                "GET",
                data
            )
                .then(data => {
                    data = data.map(item => new Comprobante(item));
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    imprimir: (uf, facturaId, periodo) => {
        return new Promise((resolve, reject) => {
            return Api.fetch(
                `${Environment.api}api/unidades-facturaciones/${uf}/comprobantes/${encodeURIComponent(facturaId)}/imprimir${periodo ? `?periodo=${encodeURIComponent(periodo)}` : ""}`,
                "GET"
            )
                .then(data => {
                    data = data.map(item => new Comprobante(item));
                    resolve(data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
};
